export default {"src":"/_next/static/media/cg.a43f20d2.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};